const csvTemplate = {
  rows: [
    ['Brandyglamorous@uol.com.br'],
    ['busyAllen@club-internet.fr'],
    ['wearyCarl@ymail.com'],
    ['Prestonpanicky@yahoo.es'],
    ['adorableMarvin78@club-internet.fr'],
    ['Mayradistinct@yahoo.es'],
  ],

  templateName: 'Email list Template',
};

// Device IDs (MAIDs/IDFAs) are UUIDs, never hashed and never email-shaped, so
// the email template above is not a usable starting point for them -- handing a
// user those addresses under a "Device IDs" button produces a file where every
// row fails validation. Synthetic UUIDs, deliberately not real advertising IDs.
//
// Mixed case on purpose: uploads are matched case-insensitively and normalized
// to lowercase, and the template is the natural place to show that.
const deviceIdCsvTemplate = {
  rows: [
    ['cf916052-6364-4b92-b860-80ea78cd2343'],
    ['CB775082-6E3D-4B52-8E6E-1A6C99BA3BB7'],
    ['ed9f0342-4b12-47f5-8048-602aeb82843d'],
    ['999e0064-c07a-4468-af29-38baad78ef50'],
    ['A846C983-0E65-45F2-9C27-AEA5F5812BB1'],
    ['54b2e788-d4fb-4b06-98f4-998ec22e5371'],
  ],

  templateName: 'Device ID list Template',
};

export const HashedEmailConfig = {
  csvTemplate,
};

export const DeviceIdConfig = {
  csvTemplate: deviceIdCsvTemplate,
};
